import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-register-validation',
  templateUrl: './register-validation.component.html',
  styleUrls: ['./register-validation.component.scss']
})
export class RegisterValidationComponent implements OnInit, OnDestroy {
  private static validatedTokens = new Set<string>();
  message = 'Verificando cuenta...';
  status: 'loading' | 'success' | 'error' = 'loading';
  private redirectTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.paramMap.get('token');
    if (!token) {
      this.showError();
      this.scheduleRedirect();
      return;
    }

    if (RegisterValidationComponent.validatedTokens.has(token)) {
      this.status = 'success';
      this.message =
        'Cuenta verificada correctamente. Redirigiendo al login...';
      this.scheduleRedirect();
      return;
    }

    this.http
      .get<any>(`${environment.serverUrl}/auth/register/${token}`)
      .pipe(
        tap((ok: any) => {
          const isOk =
            ok === true ||
            ok === 'true' ||
            ok === 1 ||
            (ok &&
              typeof ok === 'object' &&
              (ok.ok === true || ok.success === true || ok.data === true));
          if (isOk) {
            this.status = 'success';
            this.message =
              'Cuenta verificada correctamente. Redirigiendo al login...';
            RegisterValidationComponent.validatedTokens.add(token);
          } else {
            this.showError();
          }
        }),
        catchError((err: any) => {
          const payload = err?.error;
          const code = Array.isArray(payload) ? payload[0]?.code : payload?.code;
          if (code === 'EAUTH010') {
            this.status = 'success';
            this.message =
              'Cuenta verificada correctamente. Redirigiendo al login...';
            RegisterValidationComponent.validatedTokens.add(token);
          } else {
            if (this.status !== 'success') {
              this.showError();
            }
          }
          return of(null);
        }),
        finalize(() => this.scheduleRedirect())
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    if (this.redirectTimer) {
      clearTimeout(this.redirectTimer);
    }
  }

  private showError(): void {
    this.status = 'error';
    this.message = 'El enlace no es válido o ha caducado.';
  }

  private scheduleRedirect(): void {
    if (this.redirectTimer) {
      return;
    }
    this.redirectTimer = setTimeout(() => {
      this.router.navigateByUrl('/login');
    }, 2500);
  }
}
